import { api } from "../../api";

export const movieDetailsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMovieDetails: builder.query({
      query: (id) => ({
        url: "/video/get",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }), // invia l'id nel body!
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetMovieDetailsQuery } = movieDetailsApi;
